import {
  Grid,
  Typography,
  Divider,
  IconButton,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import React, { Fragment } from "react";
import { useQuery } from "@tanstack/react-query";
import HttpService from "../services/HttpService";
import PaidIcon from "@mui/icons-material/Paid";
import MailIcon from "@mui/icons-material/Mail";
import NumbersIcon from "@mui/icons-material/Numbers";
import ArticleIcon from "@mui/icons-material/Article";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import Labels from "../labels/Labels";

import { DataGrid, GridToolbar } from "@mui/x-data-grid";

export default function CampaignEventDetail(props) {
  const { campaignSelectedItem } = props;
  const columns = [
    { field: "idEvent", headerName: "ID", width: 90, hidden: true },
    {
      field: "eventName",
      headerName: Labels.getLabel(
        "campaignEventDetail.eventName",
        "Event Name"
      ),
      width: 150,
    },
    {
      field: "description",
      headerName: Labels.getLabel(
        "campaignEventDetail.description",
        "Description"
      ),
      width: 250,
    },
    {
      field: "status",
      headerName: Labels.getLabel("campaignEventDetail.status", "Status"),
      width: 140,
    },
    {
      field: "eventDate",
      headerName: Labels.getLabel(
        "campaignEventDetail.eventDate",
        "Event Date"
      ),
      width: 180,
    },
  ];

  async function fetchCampaignEventInfoDetail() {
    if (campaignSelectedItem?.email === undefined) return null;
    var url =
      window.API_URL +
      `/member/events?email=${campaignSelectedItem?.email}&status=CREATED&type=CAMPAIGN&id=${campaignSelectedItem?.id}`;
    const response = await HttpService.getAxiosClient().get(url);
    return response;
  }

  const { data, isError, isLoading } = useQuery(
    ["campaignEventInfoDetail", campaignSelectedItem?.email],
    fetchCampaignEventInfoDetail
  );

  return (
    <Fragment>
      {isLoading ? (
        <h4>{Labels.getLabel("campaignEventDetail.loading", "Loading...")}</h4>
      ) : !isError ? (
        <Fragment>
          <Grid
            style={{ marginLeft: "20px", marginRight: "20px", marginTop: 0 }}
            container
            spacing={1}
          ></Grid>
          <div style={{ height: 350 }}>
            <DataGrid
              columnVisibilityModel={{ id: false }}
              disableSelectionOnClick
              disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              rows={data?.data}
              getRowId={(row) => row.idEvent}
              columns={columns}
              getRowHeight={() => 35}
              density="compact"
              pageSize={10}
              rowsPerPageOptions={[10]}
              components={{ Toolbar: GridToolbar }}
              componentsProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </div>
        </Fragment>
      ) : (
        <h4>
          {Labels.getLabel(
            "campaignEventDetail.error",
            "An error occurred, please try again later..."
          )}
        </h4>
      )}
    </Fragment>
  );
}
